import React from 'react';
import { Formik, Field, Form } from 'formik';
import { HiOutlineRefresh } from 'react-icons/hi';
import 'bootstrap/dist/css/bootstrap.min.css';

import './DataFilterTickets.css'
import isFilled from '../../shared/utilities/isFilled.js';

const DataFilterTickets = (props) => {
    const {user, dataTicketsAux, formikValues, setFormikValues, installations, resetTicketFilters} = props

    //const[formikValues, setFormikValues] = useState({id: '', creado: '', instalacion: '*', tipo: '*', usuario: '*', asunto: '', responsable: '*', estado: '!CERRADO'})

    const types = isFilled(dataTicketsAux) ? [...new Map((dataTicketsAux).map(ticketResponse => [ticketResponse['nombreTipo'], ticketResponse.nombreTipo])).values()].sort() : []
    const filteredTicketsForUsers = isFilled(dataTicketsAux) && formikValues && formikValues.instalacion && formikValues.instalacion !== "*"
        ? dataTicketsAux.filter(ticketResponse => ticketResponse.instalacionUsuario === formikValues.instalacion)
        : dataTicketsAux;
    const ticketsForUsers = isFilled(filteredTicketsForUsers) ? filteredTicketsForUsers : dataTicketsAux;
    const users = isFilled(ticketsForUsers) ? [...new Map((ticketsForUsers).map(ticketResponse => [ticketResponse['nombreUsuario'], ticketResponse.nombreUsuario])).values()].sort() : []
    const responsibles = isFilled(dataTicketsAux) ? [...new Map((dataTicketsAux).map(ticketResponse => [ticketResponse['nombreResponsable'], ticketResponse.nombreResponsable])).values()].sort() : []

    const sortedInstallations = [...installations]
    .filter(i => i !== "*")
    .sort((a, b) => a.localeCompare(b));

    return(
        <div className = 'row'>
            <Formik
                initialValues={formikValues}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    setFormikValues(values);
                    setSubmitting(false);
                }}
            >
                {({ isSubmitting, setFieldValue, resetForm, handleSubmit, values }) => (
                    <Form>
                        <div className="row filtersRow" style={{marginBottom: "10px"}}>
                            <div className="form-group col-auto resetFilterCol">
                                <label className='labelFilter labelFilterHidden'>Reset</label>
                                <button
                                    type="button"
                                    className="btn resetFiltersIconButton"
                                    onClick={resetTicketFilters}
                                    title="Reset filtros"
                                    aria-label="Reset filtros"
                                >
                                <HiOutlineRefresh />
                            </button>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="id" className='labelFilter'>Id</label>
                                <Field id="id" name="id" className="form-control fieldFilter" type="text" onChange = {(event) => {setFieldValue("id", event.target.value); handleSubmit()}}/>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="tipo" className='labelFilter'>Tipo</label>
                                <Field id="tipo" name="tipo" className="form-control fieldFilter" as="select" onChange = {(event) => {setFieldValue("tipo", event.target.value); handleSubmit()}}>
                                    <option value="*" defaultValue>*</option>
                                    {types.map((type, i) => (
                                        <option key={i} value={type}>{type}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="asunto" className='labelFilter'>Asunto</label>
                                <Field id="asunto" name="asunto" className="form-control fieldFilter" type="text" onChange = {(event) => {setFieldValue("asunto", event.target.value); handleSubmit()}}/>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="instalacion" className='labelFilter'>Instalación</label>
                                <Field id="instalacion" name="instalacion" className="form-control fieldFilter" as="select" onChange = {(event) => {
                                    const newInstallation = event.target.value;
                                    setFieldValue("instalacion", newInstallation);

                                    if(isFilled(dataTicketsAux)){
                                        const nextTicketsForUsers = newInstallation !== "*"
                                            ? dataTicketsAux.filter(ticketResponse => ticketResponse.instalacionUsuario === newInstallation)
                                            : dataTicketsAux;
                                        const nextUsers = [...new Map(nextTicketsForUsers.map(ticketResponse => [ticketResponse['nombreUsuario'], ticketResponse.nombreUsuario])).values()];

                                        if(values && values.usuario && values.usuario !== "*" && !nextUsers.includes(values.usuario)){
                                            setFieldValue("usuario", "*");
                                        }
                                    }

                                    handleSubmit();
                                }}>
                                    {user.installationId == "A01" ? <option value="*" defaultValue>*</option> : <></>}
                                    {sortedInstallations.map((installation, i) => (
                                        <option key={i} value={installation}>{installation}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="usuario" className='labelFilter'>Usuario</label>
                                <Field id="usuario" name="usuario" className="form-control fieldFilter" as="select" onChange={(event) => {const newValue = event.target.value; setFieldValue("usuario", newValue); setFormikValues(prev => ({...prev,usuario: newValue}));}}>
                                    <option value="*">*</option>
                                    {users.map((u, i) => (
                                        <option key={i} value={u}>{u}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="responsable" className='labelFilter'>Responsable</label>
                                <Field id="responsable" name="responsable" className="form-control fieldFilter" as="select" onChange = {(event) => {setFieldValue("responsable", event.target.value); handleSubmit()}}>
                                    <option value="*" defaultValue>*</option>
                                    {responsibles.map((responsible, i) => (
                                        <option key={i} value={responsible}>{responsible}</option>
                                    ))}
                                </Field>
                            </div>
                            <div className="form-group col">
                                <label htmlFor="estado" className='labelFilter'>Estado</label>
                                <Field id="estado" name="estado" className="form-control fieldFilter" as="select" onChange = {(event) => {setFieldValue("estado", event.target.value); handleSubmit()}}>
                                    <option value="*" defaultValue>*</option>
                                    <option value="PENDIENTE">PENDIENTE</option>
                                    <option value="PROCESO">PROCESO</option>
                                    <option value="CERRADO">CERRADO</option>
                                    <option value="!CERRADO">NO CERRADO</option>
                                </Field>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default DataFilterTickets;
